import { all, call } from 'redux-saga/effects';
import values from 'lodash/values';

import appSaga from 'core/modules/App/sagas';
import bonus from 'core/sagas/bonus';
import member from 'core/sagas/member';
import ocapi from 'core/sagas/ocapi';

const combinedSagas = {
  appSaga,
  bonus,
  member,
  ocapi,
};

export default function* rootSaga() {
  yield all(values(combinedSagas).map(saga => call(saga)));
}
